module.exports = __webpack_public_path__ + "static/tooltip-metadata-do-07325b739a5972048bdc1dffd61067bb.png";